import React, { useEffect, useMemo } from "react";
import styles from "./styles.css";
// import Inspection from "./images/inspection.png";
// import H2Regular from "../../shared/h2-regular/component";
// import InspectionData from "./data";
// import InspectionAccordion from "../inspection-accordion";
import HeroImage from "./images/hero-image.png";
import HeroText from "./images/hero-text.svg";
import InspectionDataList from "../inspection-data-list/component";
import InspectionProcess from "../inspection-process";
import { CMS_SLUG_CONSTANTS } from "../../../constants/optimize-constants";
// import InspectionComprehensiveComplimentry from "../inspection-comprehensive-complimentry/component";
import { PropTypes } from "prop-types";
import { RWC_COMPONENTS_TYPES } from "../rwc-landing-page/constants";
import { PAGE_SOURCE } from "../../../constants/app-constants";

// const { categories } = InspectionData;

const ThreeHundredPointInspectionInfo = ({
    fetchRwcCmsContentConnect,
    cmsContent
}) => {

    const contentDetails = useMemo(() => {
        const currentSection = cmsContent?.pageSections?.find((section) => section?.pageSection?.name === RWC_COMPONENTS_TYPES.RWC_WHATS_INSPECTED);
        return currentSection ? currentSection?.pageSection?.meta : null;
    }, [cmsContent]);
    useEffect(() => {
        window.setTimeout(() => {
            window.scrollTo(0, 0);
        });
        fetchRwcCmsContentConnect(CMS_SLUG_CONSTANTS.THREE_HUNDERED_INSPECTION);
    }, [fetchRwcCmsContentConnect]);

    return (
        <div styleName={"styles.threeHundredPointWrapper"}>
            <div styleName={"styles.freeTopStrip"}>
                <div className="container">
                    <p>Every 300 point inspection is included absolutely <span>FREE</span>. </p>
                </div>
            </div>
            <section styleName={"styles.heroImage"}>
                <img styleName={"styles.mainImage"} src={HeroImage} alt="Cars24 Quality Assured" />
                <div styleName={"styles.heroText"}>
                    <img src={HeroText} alt="Cars24 Quality Assured" />
                </div>
            </section>
            <section styleName={"styles.inspectionSection"}>
                <div className="container">
                    <div styleName={"styles.sectionWidth"}>
                        <h1 styleName={"styles.pageTitle"}>300 Point Inspection</h1>
                        <p styleName={"styles.inspectionText"}>
                            Every car you see on the Cars24 website has passed our 300 point inspection.
                            We go above and beyond the roadworthy to give you the most thorough and comprehensive check possible.
                        </p>
                        <p styleName={"styles.inspectionText"}>
                            Our highly skilled technicians inspect every aspect of the vehicle mechanically,
                            externally and internally to ensure that it passes our Cars24 quality standard.
                        </p>
                    </div>
                </div>
            </section>
            <section styleName={"styles.inspectionChecklist"}>
                <div className="container">
                    <div styleName={"styles.sectionWidth"}>
                        {contentDetails && <InspectionDataList contentData={contentDetails} pageSource={PAGE_SOURCE.THREE_HUNDERED_POINT_INSPECTION}/>}
                        {/* <div styleName={"styles.inspectionDataWrapper"}>
                            {categories.map((item, idx) => {
                                return <InspectionAccordion data={item} key={`inspectionAccordion_${idx}`} />;
                            })}
                        </div> */}
                    </div>
                </div>
            </section>
            <InspectionProcess />
            {/* <InspectionComprehensiveComplimentry /> */}
        </div>
    );
};

ThreeHundredPointInspectionInfo.propTypes = {
    fetchRwcCmsContentConnect: PropTypes.func,
    cmsContent: PropTypes.object
};

export default ThreeHundredPointInspectionInfo;
